import { Mapper } from "../../../../base/utils/mapper";
import { UserChangePasswordModel } from "../../../../domain/models/user/user-change-password.model";
import { UserChangePasswordEntity } from "../entities/user-change-password.entity";


export class UserChangePasswordImplementationRepositoryMapper extends Mapper<UserChangePasswordEntity, UserChangePasswordModel> {
    mapFrom(param: UserChangePasswordEntity): UserChangePasswordModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: UserChangePasswordModel): UserChangePasswordEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}